const ApiKeysShared = {
  fetchClinic: "fetchClinic",
  fetchClinicImages: "fetchClinicImages",
  fetchExerciseDetails: "fetchExerciseDetails",
  fetchIFULanguages: "fetchIFULanguages",
  fetchLegalPage: "fetchLegalPage",
  fetchLocaleCopy: "fetchLocaleCopy",
  fetchNextSession: "fetchNextSession",
  fetchPatient: "fetchPatient",
  fetchPrescriptionFileType: "fetchPrescriptionFileType",
  fetchReleaseNotes: "fetchReleaseNotes",
  fetchSessionFeedback: "fetchSessionFeedback",
  fetchSound: "fetchSound",
  fetchTermsAndConditionsStatus: "fetchTermsAndConditionsStatus",
  fetchTreatmentTemplateDetails: "fetchTreatmentTemplateDetails",
  fetchTreatmentTemplatesDetails: "fetchTreatmentTemplatesDetails",
} as const;

const ApiKeysPortal = {
  emailAlreadyExists: "emailAlreadyExists",
  fetchBlogPosts: "fetchBlogPosts",
  fetchDifficultyOptions: "fetchDifficultyOptions",
  fetchExerciseSummaries: "fetchExerciseSummaries",
  fetchExerciseTemplate: "fetchExerciseTemplate",
  fetchInvitedPatientPrescription: "fetchPrescriptionInvitedPatient",
  fetchInvitedPatients: "fetchInvitedPatients",
  fetchMistakesText: "fetchMistakesText",
  fetchMistakesVideos: "fetchMistakesVideos",
  fetchMyTherapist: "fetchMyTherapist",
  updateMyTherapist: "updateMyTherapist",
  fetchPoseSequence: "fetchPoseSequence",
  fetchPrescriptionUrls: "fetchPrescriptionUrls",
  fetchRoutineDifficulties: "fetchRoutineDifficulties",
  fetchSettings: "fetchSettings",
  fetchTherapistsForClinic: "fetchTherapistsForClinic",
  fetchTherapyPlans: "fetchTherapyPlans",
  fetchTreatmentsForClinic: "fetchTreatmentsForClinic",
  fetchTreatmentsOverview: "fetchTreatmentsOverview",
  fetchTreatmentSummary: "fetchTreatmentSummary",
  getPlannedTreatment: "getPlannedTreatment",
  resetPlannedRoutine: "resetPlannedRoutine",
  resetPlannedSession: "resetPlannedSession",
  resetPlannedTreatment: "resetPlannedTreatment",
  updatePlannedRoutine: "updatePlannedRoutine",
  updatePlannedSession: "updatePlannedSession",
  updatePlannedTreatment: "updatePlannedTreatment",
  fetchReviewTask: "fetchReviewTask",
  fetchFavouriteExercises: "fetchFavouriteExercises",
  patchFavouriteExercises: "patchFavouriteExercises",
  fetchPersonalizations: "fetchPersonalizations",
  fetchTreatmentTemplateWithPersonalizations: "fetchTreatmentTemplateWithPersonalizations",
} as const;

const ApiKeysCare = {
  fetchActiveTreatment: "fetchActiveTreatment",
  fetchClinics: "fetchClinics",
  fetchDisplayHappinessQuestionnaire: "fetchDisplayHappinessQuestionnaire",
  fetchOnboardingStatus: "fetchOnboardingStatus",
  fetchSessionRecap: "fetchSessionRecap",
  fetchShorts: "fetchShorts",
  fetchSoundByKey: "fetchSoundByKey",
  fetchSupportContacts: "fetchSupportContacts",
  fetchTherapist: "fetchTherapist",
  fetchTherapists: "fetchTherapists",
  fetchTreatments: "fetchTreatments",
  fetchProgressData: "fetchProgressData",
  updatePatient: "updatePatient",
  fetchImageByKey: "fetchImageByKey",
} as const;

export const QueryKeys = {
  ...ApiKeysShared,
  ...ApiKeysPortal,
  ...ApiKeysCare,
} as const;
